import { ICriteriaCommand } from "@Criteria/cqrs";
import { DiscreteScaleLevel } from "@Scales/Model";

export class DeleteCriterionCommandV1 implements ICriteriaCommand {
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.DeleteCriterionCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	WorkspaceId: number;

	constructor(chId: number, criterionId: number, workspaceId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.DeleteCriterionCommandV1, TCh.Domain.Criteria'
	}
}

export class ChangeCriterionParentCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.ChangeCriterionParentCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	ParentId: number;
	WorkspaceId: number;

	constructor(chId: number, criterionId: number, parentId: number, workspaceId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.ParentId = parentId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.ChangeCriterionParentCommandV1, TCh.Domain.Criteria'
	}
}

export class UpdateCriterionCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.UpdateCriterionCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	Name: string;
	Description: string;
	WorkspaceId: number;

	constructor(chId: number, criterionId: number, name: string, description: string, workspaceId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.Name = name;
		this.Description = description;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.UpdateCriterionCommandV1, TCh.Domain.Criteria'
	}
}

export class CreateCriteriaFromStringCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriteriaFromStringCommandV1, TCh.Domain.Criteria';

	Id: string;
	ParentId: number;
	CriteriaString: string;
	WorkspaceId: number;

	constructor(chId: number, parentId: number, criteriaString: string, workspaceId: number)
	{
		this.Id = chId.toString();
		this.ParentId = parentId;
		this.CriteriaString = criteriaString;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriteriaFromStringCommandV1, TCh.Domain.Criteria'
	}
}


export class CreateCriterionCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionCommandV1, TCh.Domain.Criteria';

	Id: string;
	ParentId: number;
	Name: string;
	Description: string;
	WorkspaceId: number;

	constructor(chId: number, parentId: number, name: string, desc: string, workspaceId: number)
	{
		this.Id = chId.toString();
		this.ParentId = parentId;
		this.Name = name;
		this.Description = desc;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionCommandV1, TCh.Domain.Criteria'
	}
}

export class CreateCriterionFromAttributeCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionFromAttributeCommandV1, TCh.Domain.Criteria';

	Id: string;
	ParentId: number;	
	AttributeId: number;
	WorkspaceId: number;
	Name: string;

	constructor(chId: number, parentId: number, attributeId: number, name: string, workspaceId: number)
	{
		this.Id = chId.toString();
		this.ParentId = parentId;
		this.AttributeId = attributeId;
		this.WorkspaceId = workspaceId;
		this.Name = name;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionFromAttributeCommandV1, TCh.Domain.Criteria'
	}
}

export class CreateCriterionFromTemplateCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionFromTemplateCommandV1, TCh.Domain.Criteria';

	Id: string;
	ParentId: number;
	Name: string;
	AttributeId: number;
	WorkspaceId: number;

	constructor(chId: number, parentId: number, name: string, attributeId: number, workspaceId: number)
	{
		this.Id = chId.toString();
		this.ParentId = parentId;
		this.Name = name;
		this.AttributeId = attributeId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.CreateCriterionFromTemplateCommandV1, TCh.Domain.Criteria'
	}
}


export class AssignAttributeMeasurementCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.AssignAttributeMeasurementCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	AttributeId: number;
	WorkspaceId: number;

	constructor(workspaceId: number, chId: number, criterionId: number, attributeId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.AttributeId = attributeId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.AssignAttributeMeasurementCommandV1, TCh.Domain.Criteria'
	}
}

export class AssignCustomScaleMeasurementCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.AssignCustomScaleMeasurementCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	WorkspaceId: number;
	ScaleLevels: DiscreteScaleLevel[];

	constructor(wsId: number, chId: number, criterionId: number, scaleLevels: DiscreteScaleLevel[])
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.WorkspaceId = wsId;
		this.ScaleLevels = scaleLevels;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.AssignCustomScaleMeasurementCommandV1, TCh.Domain.Criteria'
	}
}

export class AssignPairwiseMeasurementCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.AssignPairwiseMeasurementCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	WorkspaceId: number;

	constructor(wsId: number, chId: number, criterionId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.WorkspaceId = wsId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.AssignPairwiseMeasurementCommandV1, TCh.Domain.Criteria'
	}
}

export class AssignScaleTemplateMeasurementCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.AssignScaleTemplateMeasurementCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	WorkspaceId: number;
	ScaleTemplateId: number;

	constructor(wsId: number, chId: number, criterionId: number, scaleTemplateId: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.WorkspaceId = wsId;
		this.ScaleTemplateId = scaleTemplateId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.AssignScaleTemplateMeasurementCommandV1, TCh.Domain.Criteria'
	}
}

export class UpdateCriterionMeasurementCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.UpdateCriterionMeasurementCommandV1, TCh.Domain.Criteria';

	Id: string;
	CriterionId: number;
	WorkspaceId: number;
	AttributeId: number;
	MaxValue: number;

	constructor(wsId: number, chId: number, criterionId: number, attrId: number, maxValue: number)
	{
		this.Id = chId.toString();
		this.CriterionId = criterionId;
		this.WorkspaceId = wsId;
		this.AttributeId = attrId;
		this.MaxValue = maxValue;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.UpdateCriterionMeasurementCommandV1, TCh.Domain.Criteria'
	}
}



export class ChangeDefaultWeightsSetCommandV1 implements ICriteriaCommand
{
	$type: string = 'TCh.Domain.Criteria.Hierarchies.Commands.ChangeDefaultWeightsSetCommandV1, TCh.Domain.Criteria';

	Id: string;
	OldDefaultId: number;
	NewDefaultId: number;
	WorkspaceId: number;

	constructor(workspaceId: number, chId: number, oldDefaultId: number, newDefaultId: number)
	{
		this.Id = chId.toString();
		this.OldDefaultId = oldDefaultId;
		this.NewDefaultId = newDefaultId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICriteriaCommand)
	{
		return cmd.$type == 'TCh.Domain.Criteria.Hierarchies.Commands.ChangeDefaultWeightsSetCommandV1, TCh.Domain.Criteria'
	}
}